import {
  FETCH_ACTIVITY_SUGGESTIONS,
  FETCH_ACTIVITY_SUGGESTIONS_SUCCESS,
  FETCH_ACTIVITY_SUGGESTIONS_FAILURE,
  GENERATE_ACTIVITY_PLAN,
  GENERATE_ACTIVITY_PLAN_DONE,
  ACCEPT_ACTIVITY_SUGGESTION,
  DISMISS_ACTIVITY_SUGGESTION,
  CONFIRM_DRAFT_ACTIVITY,
  DISCARD_DRAFT_ACTIVITY,
  REFINE_ACTIVITY_SUGGESTION,
  SET_PLANNER_BUSY,
} from "./constants";

export const fetchActivitySuggestions = (payload) => ({
  type: FETCH_ACTIVITY_SUGGESTIONS,
  payload, // { locationId }
});
export const fetchActivitySuggestionsSuccess = (payload) => ({
  type: FETCH_ACTIVITY_SUGGESTIONS_SUCCESS,
  payload,
});
export const fetchActivitySuggestionsFailure = () => ({
  type: FETCH_ACTIVITY_SUGGESTIONS_FAILURE,
});

export const generateActivityPlan = (payload, onDone) => ({
  type: GENERATE_ACTIVITY_PLAN,
  payload, // { locationId, mode, activityType?, force? }
  onDone,
});
export const generateActivityPlanDone = (payload) => ({
  type: GENERATE_ACTIVITY_PLAN_DONE,
  payload, // { aiUnavailable?, reason? }
});

export const acceptActivitySuggestion = (payload, onAccepted) => ({
  type: ACCEPT_ACTIVITY_SUGGESTION,
  payload, // { locationId, uuid }
  onAccepted, // (activityId) => open the complete-details modal
});
export const dismissActivitySuggestion = (payload) => ({
  type: DISMISS_ACTIVITY_SUGGESTION,
  payload, // { locationId, uuid, reason }
});
export const confirmDraftActivity = (payload, onDone) => ({
  type: CONFIRM_DRAFT_ACTIVITY,
  payload, // { locationId, activityId, fields }
  onDone,
});
export const discardDraftActivity = (payload) => ({
  type: DISCARD_DRAFT_ACTIVITY,
  payload, // { locationId, activityId }
});
export const refineActivitySuggestion = (payload, onDone) => ({
  type: REFINE_ACTIVITY_SUGGESTION,
  payload, // { locationId, uuid, instruction }
  onDone,
});
export const setPlannerBusy = (uuid) => ({
  type: SET_PLANNER_BUSY,
  payload: uuid,
});
